import React, { useState, useEffect, useRef } from 'react';
//import { Eye, Bot, BrainCircuit, FileText, Sparkles, CheckCircle, ArrowRight, PartyPopper, UserPlus, LogIn, LogOut, RefreshCw, User, LayoutDashboard, Phone, Copy, Check, XCircle, Beaker, KeyRound, Mic } from 'lucide-react';
import { Eye, Bot, BrainCircuit, FileText, Sparkles, CheckCircle, ArrowRight, PartyPopper, UserPlus, LogIn, LogOut, RefreshCw, User, LayoutDashboard, Phone, Copy, Check, XCircle, Beaker, KeyRound, Mic, Youtube } from 'lucide-react';

// Imports do Firebase
import { initializeApp } from 'firebase/app';
//import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { getFirestore, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import {
    getAuth,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    onAuthStateChanged,
    signOut
} from "firebase/auth";


// Colocar em produção, caminho web
const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:4242').replace(/\/$/, '');

// --- Configuração do Firebase ---
const firebaseConfig = {
    apiKey: "AIzaSyBQThmsyjFrHCUtryuN99TSIZMkAAFSOzk",
    authDomain: "bd-i4uai.firebaseapp.com",
    projectId: "bd-i4uai",
    storageBucket: "bd-i4uai.appspot.com",
    messagingSenderId: "397832259930",
    appId: "1:397832259930:web:730eefc14a3261aca58b63"
};


// Inicializa o Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);


// --- Componente do Modal de Termos de Serviço ---
const TermsModal = ({ onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[60] p-4">
            <div className="bg-gray-800 rounded-2xl max-w-3xl w-full h-[90vh] p-8 shadow-lg flex flex-col">
                <h2 className="text-2xl font-bold text-white mb-4 text-center">Contrato de Prestação de Serviços e Termos de Uso da I4Uai</h2>
                <div className="flex-grow overflow-y-auto pr-4 text-gray-300 space-y-4 text-sm">
                    <p><strong>Cláusula 1 – Objeto</strong><br/>Este contrato tem por objeto a prestação, pela Contratada, de acesso aos Agentes I4Uai, soluções baseadas em inteligência artificial acessíveis via APIs. Os Agentes I4Uai realizam tarefas de visão computacional, predição, análise de texto e geração de conteúdo analítico, conforme descrito nos materiais informativos fornecidos pela Contratada. A Contratada disponibiliza tais serviços mediante planos de assinatura, conforme definido na Cláusula 3.</p>
                    <p><strong>Cláusula 2 – Destinatários</strong><br/>Os serviços objeto deste contrato destinam-se a empresas (pessoas jurídicas) e desenvolvedores individuais (pessoas físicas) com capacidade civil para contratar. O acesso às APIs se dará mediante a criação de conta de usuário e a assinatura de um dos planos oferecidos pela Contratada. O Contratante declara ter poderes legais para celebrar este contrato e concorda em utilizá-lo de acordo com as leis aplicáveis.</p>
                    <p><strong>Cláusula 3 – Planos de Assinatura</strong><br/>3.1. A Contratada oferece planos de assinatura mensais que se renovam automaticamente, permitindo o uso contínuo dos Agentes I4Uai. Em momento futuro, poderá ser disponibilizada opção de assinatura anual.<br/>3.2. A contratação do plano dar-se-á mediante seleção do plano desejado na plataforma da Contratada e pagamento da mensalidade correspondente. O valor da assinatura e as condições de pagamento serão informados no momento da contratação. Diferentes planos oferecem quantidades variadas de requisições mensais, de acordo com os agentes contratados e características de cada plano.<br/>3.3. O Contratante autoriza expressamente a renovação automática de sua assinatura. Caso o pagamento não seja efetuado, o acesso aos serviços poderá ser suspenso ou cancelado, sem prejuízo das obrigações já constituídas.</p>
                    <p><strong>Cláusula 4 – Versão de Demonstração Gratuita</strong><br/>4.1. A Contratada poderá disponibilizar uma versão de demonstração gratuita (demo) dos Agentes I4Uai, sem custo, sujeita a limite de requisições pré-definido. Este limite de uso será informado ao usuário no momento do cadastro e poderá ser ajustado unilateralmente pela Contratada a qualquer momento.<br/>4.2. A versão demo tem por objetivo permitir ao usuário testar os serviços antes de contratar um plano pago. O Contratante reconhece que as funcionalidades oferecidas na demo podem ser restritas em relação aos planos pagos.<br/>4.3. A qualquer tempo, o usuário poderá optar por migrar para um plano pago. Em contrapartida, a Contratada poderá alterar as condições, os limites ou descontinuar a versão demo, comunicando previamente o usuário, sem que tal alteração constitua descumprimento deste contrato.</p>
                    <p><strong>Cláusula 5 – Proteção e Não Armazenamento de Dados</strong><br/>5.1. Os dados, informações e arquivos enviados pelo Contratante aos Agentes I4Uai são utilizados exclusivamente para o processamento da requisição solicitada e não serão armazenados pela Contratada.<br/>5.2. A Contratada compromete-se a não reter, coletar ou utilizar quaisquer dados submetidos para finalidades distintas da prestação imediata do serviço contratado. Os resultados gerados pelos Agentes pertencem ao Contratante, que mantém todos os direitos sobre seus dados originais.<br/>5.3. O Contratante é o único responsável pela veracidade, integridade e pela legalidade dos dados que submete aos Agentes. A Contratada não verifica licenças ou direitos de uso sobre dados fornecidos; caberá ao usuário assegurar que possui autorização para utilizar tais dados nos Agentes I4Uai.</p>
                    <p><strong>Cláusula 6 – Assinatura, Renovação e Cancelamento</strong><br/>6.1. A assinatura do plano escolhido terá vigência inicial de um mês e será renovada automaticamente, por períodos sucessivos de um mês, enquanto não houver manifestação em contrário.<br/>6.2. O Contratante poderá cancelar sua assinatura a qualquer momento, por meio dos canais disponibilizados na plataforma da Contratada. A partir da solicitação de cancelamento, o acesso aos serviços será encerrado imediatamente.<br/>6.3. Não haverá reembolso dos valores pagos referentes a períodos já iniciados, salvo disposição em contrário prevista na legislação aplicável. Atualmente, o cancelamento implica em término imediato do acesso sem direito a reembolso.<br/>6.4. A Contratada reserva-se o direito de, futuramente, alterar sua política de cancelamento, inclusive permitindo acesso até o fim do ciclo contratado e/ou reembolso proporcional; quaisquer alterações nessas políticas serão comunicadas previamente ao Contratante.</p>
                    <p><strong>Cláusula 7 – Aceite dos Termos</strong><br/>7.1. O presente contrato somente entrará em vigor após o aceite explícito do Contratante, por meio do acionamento do campo “Li e concordo com os Termos”, disponibilizado no momento da contratação.<br/>7.2. A utilização continuada dos serviços da Contratada implica na aceitação total e irrestrita de todas as cláusulas e condições deste contrato. Caso o Contratante não concorde com qualquer termo aqui previsto, deve desistir da contratação imediatamente.</p>
                    <p><strong>Cláusula 8 – Limitação de Responsabilidade e Uso Indevido</strong><br/>8.1. Os Agentes I4Uai fornecem resultados baseados em algoritmos de inteligência artificial que geram estimativas e previsões com base nos dados fornecidos pelo usuário. A Contratada não garante absoluta precisão, exatidão, completude ou atualidade dos resultados.<br/>8.2. O Contratante reconhece que as decisões tomadas com base nos resultados dos Agentes são de sua única responsabilidade. A Contratada não será responsável por quaisquer danos diretos, indiretos, incidentais ou consequenciais decorrentes do uso ou interpretação dos resultados. Isso inclui, mas não se limita a, perdas de lucro, interrupção de negócios ou danos à reputação.<br/>8.3. O uso dos serviços para fins ilícitos, inadequados ou que violem direitos de terceiros é expressamente proibido. O Contratante compromete-se a não utilizar os Agentes I4Uai para difusão de conteúdo ilegal, ofensivo ou que infrinja direitos autorais, de propriedade intelectual ou de privacidade de terceiros. Em caso de uso indevido, o Contratante será o único responsável por quaisquer consequências legais ou danos causados.</p>
                    <p><strong>Cláusula 9 – Alterações</strong><br/>9.1. A Contratada poderá alterar, suspender ou descontinuar, a qualquer tempo e sem aviso prévio, a oferta dos serviços, bem como atualizar ou modificar estas condições.<br/>9.2. Em caso de alterações significativas nos termos deste contrato, a Contratada envidará esforços razoáveis para notificar o Contratante com antecedência. O uso continuado dos serviços após a publicação das alterações implica na aceitação dos termos revisados.<br/>9.3. Se qualquer disposição deste contrato for considerada inválida ou inexequível, as demais disposições permanecerão em pleno vigor.</p>
                    <p><strong>Cláusula 10 – Legislação Aplicável e Foro</strong><br/>10.1. Este contrato será regido e interpretado de acordo com as leis da República Federativa do Brasil.<br/>10.2. Fica eleito o foro da Comarca de Belo Horizonte (MG) para dirimir quaisquer controvérsias oriundas deste contrato, com renúncia expressa a qualquer outro, por mais privilegiado que seja.</p>
                </div>
                <button onClick={onClose} className="mt-6 bg-orange-500 text-white font-semibold py-3 px-8 rounded-lg hover:bg-orange-600 transition-colors w-full">
                    Fechar
                </button>
            </div>
        </div>
    );
};


// --- Componente da Página de Sucesso ---
const SuccessDisplay = ({ sessionId, user }) => {
    const [sessionData, setSessionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSessionData = async () => {
            try {
                const response = await fetch(`${API_BASE}/session-status?session_id=${sessionId}`);
                if (!response.ok) throw new Error('Não foi possível obter os dados da sua assinatura.');
                const data = await response.json();
                setSessionData(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchSessionData();
    }, [sessionId]);

    if (loading) return <div className="flex justify-center items-center h-screen bg-gray-900 text-white"><p className="text-2xl">A verificar o seu pagamento...</p></div>;
    if (error) return <div className="flex justify-center items-center h-screen bg-gray-900 text-white"><p className="text-2xl text-red-500">Erro: {error}</p></div>;

    return (
        <div className="bg-gray-900 min-h-screen flex items-center justify-center p-4">
            <div className="bg-gray-800 border-2 border-green-500 rounded-2xl max-w-2xl w-full p-8 text-center shadow-lg">
                <PartyPopper className="h-16 w-16 text-green-400 mx-auto mb-4" />
                <h1 className="text-4xl font-extrabold text-white mb-2">Pagamento Concluído!</h1>
                <p className="text-gray-400 text-lg mb-8">Obrigado pela sua assinatura. A sua chave de API já está disponível na sua conta.</p>
                <div className="bg-gray-900 rounded-lg p-6 text-left space-y-4">
                    <div className="flex justify-between items-center"><span className="text-gray-400">Email:</span><span className="font-semibold text-white">{sessionData?.customer_email}</span></div>
                    <div className="flex justify-between items-center"><span className="text-gray-400">Plano Contratado:</span><span className="font-semibold text-white">{sessionData?.product_name}</span></div>
                    <div className="flex justify-between items-center"><span className="text-gray-400">Valor:</span><span className="font-semibold text-white">{(sessionData?.amount_total / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span></div>
                </div>
                <a href="/" className="mt-8 inline-block bg-orange-500 text-white font-semibold py-3 px-8 rounded-lg hover:bg-orange-600 transition-colors">Ir para a Minha Conta</a>
            </div>
        </div>
    );
};

// --- Componente do Modal de Autenticação (Registo e Login) ---
const AuthModal = ({ plan, onClose, onAuthSuccess }) => {
    const [isLogin, setIsLogin] = useState(true);
    const [formData, setFormData] = useState({ name: '', company: '', email: '', phone: '', password: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [showTerms, setShowTerms] = useState(false);

    const isDemoPlan = plan?.type === 'demo';

    const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            if (isLogin) {
                const userCredential = await signInWithEmailAndPassword(auth, formData.email, formData.password);
                onAuthSuccess(userCredential.user);
            } else {
                const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
                const user = userCredential.user;
                
                await setDoc(doc(db, "clientes", user.uid), {
                    name: formData.name,
                    company: formData.company,
                    email: formData.email,
                    phone: formData.phone,
                    createdAt: serverTimestamp() 
                });

                onAuthSuccess(user);
            }
        } catch (err) {
            let friendlyMessage = 'Ocorreu um erro. Tente novamente.';
            if (err.code) { 
                switch (err.code) {
                    case 'auth/email-already-in-use': friendlyMessage = 'Este email já está registado. Tente fazer login.'; break;
                    case 'auth/invalid-email': friendlyMessage = 'O formato do email é inválido.'; break;
                    case 'auth/weak-password': friendlyMessage = 'A sua palavra-passe é muito fraca. Use pelo menos 6 caracteres.'; break;
                    case 'auth/invalid-credential': friendlyMessage = 'Email ou palavra-passe inválidos.'; break;
                    case 'permission-denied': friendlyMessage = 'Erro de permissão com a base de dados. Verifique as regras do Firestore.'; break;
                    default: friendlyMessage = `Erro inesperado: ${err.code}`;
                }
            }
            setError(friendlyMessage);
            setIsLoading(false);
        }
    };
    
    const getButtonText = () => {
        if (isLoading) return 'A processar...';
        if (isLogin) {
            return isDemoPlan ? 'Entrar' : (plan?.priceId ? 'Entrar e Pagar' : 'Entrar');
        } else {
            return isDemoPlan ? 'Registrar' : (plan?.priceId ? 'Registrar e Pagar' : 'Registrar');
        }
    };

    return (
        <>
            {showTerms && <TermsModal onClose={() => setShowTerms(false)} />}
            <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
                <div className="bg-gray-800 rounded-2xl max-w-md w-full p-8 shadow-lg relative">
                    <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white">&times;</button>
                    <div className="text-center mb-6">
                        {isLogin ? <LogIn className="h-12 w-12 text-orange-400 mx-auto mb-3" /> : <UserPlus className="h-12 w-12 text-orange-400 mx-auto mb-3" />}
                        <h2 className="text-2xl font-bold text-white">{isLogin ? 'Bem-vindo de volta!' : 'Crie a sua conta'}</h2>
                        {plan?.priceId ? (
                            <p className="text-gray-400">Para ativar o plano <span className="font-bold text-orange-400">{plan.title}</span>.</p>
                        ) : (
                            <p className="text-gray-400">{isLogin ? 'Faça login para aceder à sua conta.' : 'Crie uma conta para continuar.'}</p>
                        )}
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-4">
                            {!isLogin && (
                                <>
                                    <input type="text" name="name" placeholder="Nome Completo" value={formData.name} onChange={handleChange} required className="w-full bg-gray-900 border border-gray-700 text-white rounded-lg p-3 focus:ring-orange-500 focus:border-orange-500" />
                                    <input type="text" name="company" placeholder="Empresa (Opcional)" value={formData.company} onChange={handleChange} className="w-full bg-gray-900 border border-gray-700 text-white rounded-lg p-3 focus:ring-orange-500 focus:border-orange-500" />
                                    <input type="tel" name="phone" placeholder="Telefone" value={formData.phone} onChange={handleChange} required className="w-full bg-gray-900 border border-gray-700 text-white rounded-lg p-3 focus:ring-orange-500 focus:border-orange-500" />
                                </>
                            )}
                            <input type="email" name="email" placeholder="Seu Melhor Email" value={formData.email} onChange={handleChange} required className="w-full bg-gray-900 border border-gray-700 text-white rounded-lg p-3 focus:ring-orange-500 focus:border-orange-500" />
                            <input type="password" name="password" placeholder="Palavra-passe (mín. 6 caracteres)" value={formData.password} onChange={handleChange} required className="w-full bg-gray-900 border border-gray-700 text-white rounded-lg p-3 focus:ring-orange-500 focus:border-orange-500" />
                        </div>

                        {plan?.priceId && (
                            <div className="mt-4 flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="terms"
                                    checked={termsAccepted}
                                    onChange={() => setTermsAccepted(!termsAccepted)}
                                    className="h-4 w-4 rounded border-gray-600 bg-gray-900 text-orange-500 focus:ring-orange-600"
                                />
                                <label htmlFor="terms" className="text-sm text-gray-400">
                                    Eu li e concordo com os{' '}
                                    <button type="button" onClick={() => setShowTerms(true)} className="font-semibold text-orange-400 hover:underline">
                                        Termos de Serviço
                                    </button>
                                </label>
                            </div>
                        )}

                        {error && <p className="text-red-500 text-sm mt-4 text-center">{error}</p>}
                        
                        <button 
                            type="submit" 
                            disabled={isLoading || (plan?.priceId && !termsAccepted)} 
                            className="w-full mt-6 bg-orange-500 text-white font-semibold py-3 rounded-lg hover:bg-orange-600 transition-colors disabled:bg-gray-500 disabled:cursor-not-allowed"
                        >
                           {getButtonText()}
                        </button>
                    </form>
                    <p className="text-center text-sm text-gray-400 mt-4">
                        {isLogin ? 'Não tem uma conta?' : 'Já tem uma conta?'}
                        <button onClick={() => setIsLogin(!isLogin)} className="font-semibold text-orange-400 hover:underline ml-1">
                            {isLogin ? 'Registre-se' : 'Faça login'}
                        </button>
                    </p>
                </div>
            </div>
        </>
    );
};

// --- Componente da Página de Preços ---
const PricingPage = ({ user, onShowDashboard, onShowAgents, onActivationSuccess }) => {
    const [modalPlan, setModalPlan] = useState(null);
    const [isAuthForAccount, setIsAuthForAccount] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const proceedToCheckout = async (plan, email, userId) => {
        setIsLoading(true);
        try {
            //const stripe = window.Stripe('pk_test_51RTjYBQnIdzjL6em81PYkMESbvOPfvHVLQSsjQ9HIM0MyK2tknaCtF8775dQbNoIfqMdEWoVI3AqrWVDAKGQ0uCY00oqwED37V');
            const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

            if (!stripe) throw new Error('Stripe.js não foi carregado.');

            const response = await fetch(`${API_BASE}/create-checkout-session`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    priceId: plan.priceId, 
                    email: email,
                    planName: plan.title,
                    requests: plan.requests,
                    userId: userId
                }),
            });

            if (!response.ok) throw new Error((await response.json()).error || 'Falha ao criar a sessão de checkout.');
            
            const session = await response.json();
            await stripe.redirectToCheckout({ sessionId: session.id });

        } catch (error) {
            alert(`Não foi possível iniciar o processo de assinatura: ${error.message}`);
        } finally {
            setIsLoading(false);
            setModalPlan(null);
        }
    };

    const activateDemoPlan = async (plan, authenticatedUser) => {
        setIsLoading(true);
        try {
            const simplifiedPlan = {
                title: plan.title,
                requests: plan.requests,
                priceId: plan.priceId,
                type: plan.type
            };

            const response = await fetch(`${API_BASE}/activate-demo`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    plan: simplifiedPlan,
                    userId: authenticatedUser.uid,
                    userName: authenticatedUser.displayName || 'Utilizador Demo'
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Falha ao ativar o plano de demonstração.');
            }

            alert('Plano de demonstração ativado com sucesso! A sua chave de API está disponível no seu painel.');
            onActivationSuccess();

        } catch (error) {
            alert(`Erro: ${error.message}`);
        } finally {
            setIsLoading(false);
            setModalPlan(null);
        }
    };

    const handleSelectPlan = (plan, tierIndex = null) => {
        let selectedPlan;
        if (plan.tiers && tierIndex !== null) {
            selectedPlan = { ...plan, ...plan.tiers[tierIndex], title: plan.title };
        } else {
            selectedPlan = { ...plan };
        }

        if (user) {
            if (selectedPlan.type === 'demo') {
                activateDemoPlan(selectedPlan, user);
            } else {
                proceedToCheckout(selectedPlan, user.email, user.uid);
            }
        } else {
            setModalPlan(selectedPlan);
        }
    };

    const handleAuthSuccess = (authenticatedUser) => {
        if (modalPlan) {
            if (modalPlan.type === 'demo') {
                activateDemoPlan(modalPlan, authenticatedUser);
            } else {
                proceedToCheckout(modalPlan, authenticatedUser.email, authenticatedUser.uid);
            }
        } else {
            setIsAuthForAccount(false);
            onShowDashboard();
        }
    };

    const handleMyAccountClick = () => {
        if (user) {
            onShowDashboard();
        } else {
            setIsAuthForAccount(true);
        }
    };
    
    const closeModal = () => {
        setModalPlan(null);
        setIsAuthForAccount(false);
    };

    const plans = [
      {
        type: 'demo',
        title: 'Plano Demo',
        icon: <Sparkles className="h-8 w-8 text-orange-400" />,
        description: 'Experimente todos os nossos agentes com um limite de requisições.',
        price: 'Grátis',
        requests: 20,
        priceId: 'demo_plan',
        features: [
          'Acesso a todos os agentes',
          'Visão Computacional',
          'Assistentes de IA',
          'Modelos de Predição',
          'Análise de Texto',
        ],
        cta: 'Solicitar Teste Gratuito',
        isFeatured: false,
      },
      {
        type: 'agent',
        title: 'Visão Computacional',
        icon: <Eye className="h-8 w-8 text-blue-400" />,
        description: 'Agentes para classificar imagens, detectar faces, danos em veículos e emoções.',
        features: ['I4U Data Vision', 'I4U Face Detect', 'I4U Car Crash', 'I4U Mood Sense'],
        tiers: [
          { requests: 100, price: "49,90", priceId: 'price_1S8N0LHKdDPnDxKXyzBgRbOm' },
          { requests: 500, price: "89,90", priceId: 'price_1S8N0GHKdDPnDxKX8w0yJA6j' },
          { requests: 1000, price: "169,90", priceId: 'price_1S8N04HKdDPnDxKX0Ap3W4mk' },
        ],
        cta: 'Assinar Agora',
        isFeatured: false,
      },
      {
        type: 'agent',
        title: 'Assistentes Inteligentes',
        icon: <Bot className="h-8 w-8 text-green-400" />,
        description: 'Gere queries SQL, gráficos ou podcasts de forma automática a partir de linguagem natural.',
        features: ['I4U QueryGen', 'I4U GraphGen', 'I4U Podcast'],
        tiers: [
          { requests: 100, price: "49,90", priceId: 'price_1S8N01HKdDPnDxKXHWZo1UIS' },
          { requests: 500, price: "89,90", priceId: 'price_1S8MzxHKdDPnDxKXdkaKwh6k' },
          { requests: 1000, price: "169,90", priceId: 'price_1S8MzvHKdDPnDxKXZoVLViTG' },
        ],
        cta: 'Assinar Agora',
        isFeatured: false,
      },
      {
        type: 'agent',
        title: 'Predição',
        icon: <BrainCircuit className="h-8 w-8 text-purple-400" />,
        description: 'Realize predições automáticas (variáveis categóricas ou numéricas) em seus dados.',
        features: ['I4U Predict'],
        tiers: [
          { requests: 100, price: "49,90", priceId: 'price_1S8MzqHKdDPnDxKX77DpGUTH' },
          { requests: 500, price: "89,90", priceId: 'price_1S8MzmHKdDPnDxKXpcT7UxC0' },
          { requests: 1000, price: "169,90", priceId: 'price_1S8MzhHKdDPnDxKX9jMDtniF' },
        ],
        cta: 'Assinar Agora',
        isFeatured: false,
      },
      {
        type: 'agent',
        title: 'Análise de Texto',
        icon: <FileText className="h-8 w-8 text-yellow-400" />,
        description: 'Analise sentimentos, documentos, currículos e gere resumos de forma automática.',
        features: ['I4U Feel', 'I4U Doc Analytics', 'I4U Resume', 'I4U Summary'],
        tiers: [
          { requests: 100, price: "49,90", priceId: 'price_1S8MzdHKdDPnDxKXiRjZZ31t' },
          { requests: 500, price: "89,90", priceId: 'price_1S8MzZHKdDPnDxKXxxSxYfsL' },
          { requests: 1000, price: "169,90", priceId: 'price_1S8MzUHKdDPnDxKX3b5Xtogw' },
        ],
        cta: 'Assinar Agora',
        isFeatured: false,
      },
      {
        type: 'all',
        title: 'Todos os Agentes',
        icon: <Sparkles className="h-8 w-8 text-orange-400" />,
        description: 'Acesso total a todos os agentes atuais e futuros da I4Uai com um preço único.',
        features: [
          'Todos os agentes de Visão Computacional',
          'Todos os Assistentes de IA',
          'Todos os modelos de Predição',
          'Todos os agentes de Análise de Texto',
          'Acesso antecipado a novos agentes',
        ],
        requests: 5000,
        price: "709,90",
        priceId: 'price_1S8MzNHKdDPnDxKXTaDpqfeM',
        cta: 'Assinar Pacote Completo',
        isFeatured: true
      },
    ];

    return (
        <>
            {isLoading && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70]"><RefreshCw className="h-12 w-12 text-white animate-spin" /></div>}
            {(modalPlan || isAuthForAccount) && (
                <AuthModal
                    plan={modalPlan || {}}
                    onClose={closeModal}
                    onAuthSuccess={handleAuthSuccess}
                />
            )}
            <div className="bg-gray-900 min-h-screen antialiased">
                <div className="container mx-auto px-4 py-12 md:py-20">
                    <header className="text-center mb-12 md:mb-16 relative">
                        <div className="absolute top-0 right-0 flex gap-4">
                            <button onClick={() => onShowAgents(null)} className="bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2">
                                <Beaker className="h-5 w-5" />
                                <span>Playground</span>
                            </button>
                            <button onClick={handleMyAccountClick} className="bg-gray-700 text-white font-semibold py-2 px-4 rounded-lg hover:bg-gray-600 transition-colors flex items-center gap-2">
                                <LayoutDashboard className="h-5 w-5" />
                                <span>Minha Conta</span>
                            </button>
                        </div>
                        <div className="inline-flex items-center gap-2 bg-gray-800 text-orange-400 text-sm font-semibold px-4 py-1 rounded-full mb-4">I4Uai Agents Library</div>
                        <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight">Planos Flexíveis para Cada Necessidade</h1>
                        <p className="mt-4 text-lg md:text-xl text-gray-400 max-w-3xl mx-auto">Escolha o plano ideal para seu projeto e comece a integrar o poder da inteligência artificial em suas aplicações hoje mesmo.</p>
                        <p className="mt-4 text-lg md:text-xl text-gray-400 max-w-3xl mx-auto">Precisa de um plano customizado? Entre em contato.</p>
                        <p className="mt-6 text-lg">
                            <a href="https://youtu.be/SUpHGQCxRcs" target="_blank" rel="noopener noreferrer" className="text-orange-400 hover:underline inline-flex items-center justify-center gap-2">
                                <Youtube className="h-5 w-5" />
                                <span>Ver Demonstração dos agentes</span>
                            </a>
                        </p>
                    </header>
                    <main className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-8">
                        {plans.map((plan, index) => (<PricingCard key={index} plan={plan} onSelectPlan={handleSelectPlan} />))}
                    </main>
                    <footer className="text-center mt-16 text-gray-500"><p>Dúvidas? <a href="mailto:suporte@i4uai.com.br" className="text-orange-400 hover:underline">Entre em contato com nosso suporte</a>.</p><p className="mt-2 text-sm">Os pagamentos são processados de forma segura pelo Stripe. Você pode cancelar sua assinatura a qualquer momento.</p></footer>
                </div>
            </div>
        </>
    );
};

const PricingCard = ({ plan, onSelectPlan }) => {
    const [selectedTierIndex, setSelectedTierIndex] = useState(0);
    return (
        <div className={`bg-gray-800 rounded-2xl p-6 md:p-8 flex flex-col border-2 ${plan.isFeatured ? 'border-orange-500' : 'border-gray-700'} transform hover:-translate-y-2 transition-transform duration-300 shadow-lg relative`}>
            {plan.isFeatured && <div className="absolute top-0 -translate-y-1/2 left-1/2 -translate-x-1/2 bg-orange-500 text-white text-xs font-bold px-4 py-1 rounded-full">MAIS POPULAR</div>}
            <div className="flex-grow">
                <div className="flex items-center gap-4 mb-4"><div className={`bg-gray-700 p-3 rounded-full`}>{plan.icon}</div><h3 className="text-2xl font-bold text-white">{plan.title}</h3></div>
                <p className="text-gray-400 mb-6 h-12">{plan.description}</p>
                <ul className="space-y-3 mb-8">{plan.features.map((feature, index) => (<li key={index} className="flex items-center gap-3"><CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" /><span className="text-gray-300">{feature}</span></li>))}</ul>
            </div>
            <div className="mt-auto">
                {plan.tiers ? (
                    <>
                        <div className="mb-6"><p className="text-sm text-gray-400 mb-2">Selecione o volume de requisições/mês:</p><div className="flex bg-gray-900 rounded-lg p-1">{plan.tiers.map((tier, index) => (<button key={index} onClick={() => setSelectedTierIndex(index)} className={`w-full py-2 px-1 text-sm font-semibold rounded-md transition-colors duration-300 ${selectedTierIndex === index ? 'bg-orange-500 text-white' : 'bg-transparent text-gray-300 hover:bg-gray-700'}`}>{tier.requests.toLocaleString('pt-BR')}</button>))}</div></div>
                        <div className="text-center mb-6"><span className="text-4xl font-extrabold text-white">R${plan.tiers[selectedTierIndex].price}</span><span className="text-gray-400">/mês</span></div>
                    </>
                ) : (
                    <div className="text-center mb-6 h-24 flex flex-col justify-center"><span className="text-4xl font-extrabold text-white">{plan.price === 'Grátis' ? plan.price : `R$${plan.price}`}</span>{plan.price !== 'Grátis' && <span className="text-gray-400">/mês</span>}<p className="text-gray-400 mt-1">{plan.type === 'demo' ? `Limite de ${plan.requests.toLocaleString('pt-BR')} requisições no total.` : `${plan.requests.toLocaleString('pt-BR')} requisições por mês.`}</p></div>
                )}
                <button onClick={() => onSelectPlan(plan, plan.tiers ? selectedTierIndex : null)} className={`w-full py-3 px-6 rounded-lg font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2 ${plan.isFeatured ? 'bg-orange-500 text-white hover:bg-orange-600 shadow-orange-500/30' : 'bg-blue-600 text-white hover:bg-blue-700'} ${plan.type === 'demo' && 'bg-gray-600 hover:bg-gray-500'}`}>{plan.cta}<ArrowRight className="h-5 w-5" /></button>
            </div>
        </div>
    );
};

// --- Componente do Dashboard ---
const DashboardPage = ({ user, onShowPlans, onShowAgents }) => {
    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [copiedKey, setCopiedKey] = useState(null);
    const [cancelingSubId, setCancelingSubId] = useState(null);
    const [isPortalLoading, setIsPortalLoading] = useState(false);

    const hasDemoPlan = subscriptions.some(sub => sub.planName === 'Plano Demo');
    const hasAnyPaidPlan = subscriptions.some(sub => !sub.id.startsWith('demo-'));

    const fetchSubscriptions = async () => {
        if (!user?.uid) return;
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${API_BASE}/my-subscriptions?userId=${user.uid}`);
            if (!response.ok) throw new Error('Falha ao buscar assinaturas.');
            const data = await response.json();
            setSubscriptions(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSubscriptions();
    }, [user]);

    const handleLogout = async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error("Erro ao fazer logout:", error);
            alert("Não foi possível fazer o logout. Tente novamente.");
        }
    };
    
    const handleCopyKey = (apiKey) => {
        navigator.clipboard.writeText(apiKey);
        setCopiedKey(apiKey);
        setTimeout(() => setCopiedKey(null), 2000);
    };

    const handlePortalClick = async () => {
        setIsPortalLoading(true);
        try {
            const response = await fetch(`${API_BASE}/create-portal-session`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId: user.uid }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Não foi possível aceder ao portal do cliente.');
            }
            window.location.href = data.url;
        } catch (err) {
            alert(`Erro: ${err.message}`);
            setIsPortalLoading(false);
        }
    };

    const handleCancelSubscription = async (subscriptionId) => {
        if (subscriptionId.startsWith('demo-')) {
            alert('O plano de demonstração não pode ser cancelado.');
            return;
        }

        if (!window.confirm("Tem a certeza de que deseja cancelar esta assinatura? Esta ação não pode ser desfeita.")) {
            return;
        }

        setCancelingSubId(subscriptionId);
        setError(null);

        try {
            const response = await fetch(`${API_BASE}/cancel-subscription`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userId: user.uid,
                    subscriptionId: subscriptionId
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Falha ao cancelar a assinatura.');
            }

            fetchSubscriptions(); 

        } catch (err) {
            setError(err.message);
            alert(`Erro: ${err.message}`);
        } finally {
            setCancelingSubId(null);
        }
    };

    const StatusBadge = ({ status }) => {
        const statusMap = {
            active: 'bg-green-500 text-green-100',
            trialing: 'bg-yellow-500 text-yellow-100',
            canceled: 'bg-red-500 text-red-100',
            past_due: 'bg-orange-500 text-orange-100',
            demo: 'bg-blue-500 text-blue-100',
        };
        const defaultClass = 'bg-gray-500 text-gray-100';
        return (
            <span className={`px-2 py-1 text-xs font-semibold rounded-full ${statusMap[status] || defaultClass}`}>
                {status}
            </span>
        );
    };

    return (
        <div className="bg-gray-900 min-h-screen flex items-center justify-center p-4">
            <div className="bg-gray-800 rounded-2xl max-w-6xl w-full p-8 shadow-lg">
                <div className="flex justify-between items-center mb-8">
                    <div>
                        <h1 className="text-3xl font-bold text-white">Minha Conta</h1>
                        <p className="text-gray-400">Bem-vindo, {user.email}</p>
                        <p className="text-gray-400">Para detalhes de uso verifique no menu "DESENVOLVEDOR".</p>
                    </div>
                    <div className="flex flex-wrap items-center gap-4">
                        {hasDemoPlan && (
                             <button onClick={() => onShowAgents(subscriptions.find(sub => sub.planName === 'Plano Demo').apiKey)} className="bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2">
                                <Beaker className="h-5 w-5" />
                                <span>Testar Agentes</span>
                            </button>
                        )}
                        {hasAnyPaidPlan && (
                            <button 
                               onClick={handlePortalClick} 
                               disabled={isPortalLoading}
                               className="bg-indigo-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-indigo-700 transition-colors flex items-center gap-2 disabled:bg-gray-500"
                            >
                               <User className="h-5 w-5" />
                               <span>{isPortalLoading ? 'A carregar...' : 'Portal do Cliente'}</span>
                            </button>
                        )}
                        <button onClick={onShowPlans} className="bg-orange-500 text-white font-semibold py-2 px-4 rounded-lg hover:bg-orange-600 transition-colors flex items-center gap-2">
                           <Sparkles className="h-5 w-5" />
                           <span>Ver Planos</span>
                        </button>
                        <button onClick={handleLogout} className="bg-red-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-red-700 transition-colors flex items-center gap-2">
                            <LogOut className="h-5 w-5" />
                            <span>Sair</span>
                        </button>
                    </div>
                </div>
                
                <div className="bg-gray-900 p-6 rounded-lg">
                    <h2 className="text-xl font-semibold text-white mb-4">As suas Assinaturas</h2>
                    {loading && (
                        <div className="flex justify-center items-center p-8">
                            <RefreshCw className="h-8 w-8 text-white animate-spin" />
                        </div>
                    )}
                    {error && <p className="text-red-500 text-center">{error}</p>}
                    {!loading && !error && (
                        subscriptions.length > 0 ? (
                            <div className="overflow-x-auto">
                                <table className="w-full text-left">
                                    <thead>
                                        <tr className="border-b border-gray-700">
                                            <th className="p-3 text-gray-400">Plano</th>
                                            <th className="p-3 text-gray-400">Requisições</th>
                                            <th className="p-3 text-gray-400">Estado</th>
                                            <th className="p-3 text-gray-400">Preço</th>
                                            <th className="p-3 text-gray-400">Expira em</th>
                                            <th className="p-3 text-gray-400">API Key</th>
                                            <th className="p-3 text-gray-400 text-center">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {subscriptions.map(sub => {
                                            const invalidDates = ['31/12/1969', '01/01/1970'];
                                            const displayDate = invalidDates.includes(sub.currentPeriodEnd) ? '-' : sub.currentPeriodEnd;
                                            return (
                                                <tr key={sub.id} className="border-b border-gray-800">
                                                    <td className="p-3 text-white">{sub.planName}</td>
                                                    <td className="p-3 text-white">{sub.requests ? `${sub.requests.toLocaleString('pt-BR')}/mês` : 'N/A'}</td>
                                                    <td className="p-3"><StatusBadge status={sub.status} /></td>
                                                    <td className="p-3 text-white">{sub.price}</td>
                                                    <td className="p-3 text-white">{displayDate}</td>
                                                    <td className="p-3 text-white font-mono text-sm">
                                                        {sub.apiKey ? (
                                                            <div className="flex items-center gap-2">
                                                                <span>{sub.apiKey.substring(0, 12)}...</span>
                                                                <button onClick={() => handleCopyKey(sub.apiKey)} title="Copiar API Key" className="text-gray-400 hover:text-white">
                                                                    {copiedKey === sub.apiKey ? <Check className="h-4 w-4 text-green-500" /> : <Copy className="h-4 w-4" />}
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <span className="text-gray-500">A gerar...</span>
                                                        )}
                                                    </td>
                                                    <td className="p-3 text-center">
                                                        {(sub.status === 'active' && !sub.id.startsWith('demo')) ? (
                                                            <button
                                                                onClick={() => handleCancelSubscription(sub.id)}
                                                                disabled={cancelingSubId === sub.id}
                                                                className="bg-red-600 text-white text-xs font-semibold py-1 px-3 rounded-md hover:bg-red-700 disabled:bg-gray-500 disabled:cursor-not-allowed flex items-center justify-center gap-1"
                                                            >
                                                                <XCircle className="h-4 w-4" />
                                                                {cancelingSubId === sub.id ? 'A cancelar...' : 'Cancelar'}
                                                            </button>
                                                        ) : (
                                                           <span className="text-gray-500 text-xs italic">N/A</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center text-gray-500 border-2 border-dashed border-gray-700 p-8 rounded-lg">
                                <p>Ainda não tem assinaturas ativas.</p>
                                <button onClick={onShowPlans} className="mt-4 inline-block text-orange-400 hover:underline bg-transparent border-none">
                                    Ver Planos
                                </button>
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

// --- Componente de Visualização para Imagens com Canvas ---
const ImageResultDisplay = ({ agentId, fileURL, visualData }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const detections = Array.isArray(visualData) 
            ? visualData 
            : visualData?.detections;

        if (!fileURL || !canvasRef.current || !detections || detections.length === 0) {
            return;
        }

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const img = new Image();

        img.onload = () => {
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            ctx.drawImage(img, 0, 0);
            const scale = canvas.clientWidth / canvas.width;

            detections.forEach(det => {
                if (!det.box) return;
                const [x, y, width, height] = det.box;
                const label = det.label || 'detecção';
                const lowerCaseLabel = label.toLowerCase();
                const color = lowerCaseLabel.includes('dano') || lowerCaseLabel.includes('batida') ? '#FF6347' : '#32CD32';

                ctx.strokeStyle = color;
                ctx.lineWidth = 3 / scale; 
                ctx.strokeRect(x, y, width, height);
                
                const confidenceText = `(${(det.confidence * 100).toFixed(1)}%)`;
                const fullText = `${label} ${confidenceText}`;
                
                const fontSize = 16 / scale;
                ctx.font = `bold ${fontSize}px Arial`;
                const textWidth = ctx.measureText(fullText).width;
                
                ctx.fillStyle = color;
                ctx.fillRect(x, y > (fontSize + 2) ? y - (fontSize + 2) : y, textWidth + (10 / scale), (fontSize + 2));

                ctx.fillStyle = '#FFFFFF';
                ctx.fillText(fullText, x + (5 / scale), y > (fontSize + 2) ? y - (2 / scale) : y + fontSize);
            });
        };

        img.onerror = () => {
            console.error("Erro ao carregar a imagem para o canvas:", fileURL);
        };

        img.src = fileURL;

    }, [fileURL, visualData, canvasRef.current?.clientWidth]);

    return (
        <div className="mt-4">
             <h4 className="text-md font-semibold text-white mb-2">Visualização:</h4>
             <div className="bg-gray-900 p-2 rounded-md">
                <canvas ref={canvasRef} id={`canvas-${agentId}`} className="w-full h-auto" />
             </div>
        </div>
    );
};

// --- Componente de Visualização para Vídeo ---
const VideoResultDisplay = ({ agentId, fileURL, visualData }) => {
    const videoRef = useRef(null);
    const [currentEmotion, setCurrentEmotion] = useState('');

    const handleTimeUpdate = () => {
        if (!videoRef.current || !visualData || !Array.isArray(visualData)) return;

        const currentTime = videoRef.current.currentTime;
        const relevantEmotion = visualData
            .filter(e => e.tempo_segundos <= currentTime)
            .pop();

        if (relevantEmotion) {
            setCurrentEmotion(relevantEmotion.emocao);
        }
    };

    if (!fileURL || !visualData) return null;

    return (
        <div className="mt-4">
            <h4 className="text-md font-semibold text-white mb-2">Visualização:</h4>
            <div className="relative bg-gray-900 p-2 rounded-md">
                <video 
                    ref={videoRef}
                    id={`video-${agentId}`} 
                    src={fileURL} 
                    controls 
                    onTimeUpdate={handleTimeUpdate}
                    className="w-full h-auto rounded"
                />
                {currentEmotion && (
                    <div className="absolute top-4 left-4 bg-black bg-opacity-60 text-white text-lg font-bold p-2 rounded capitalize">
                        {currentEmotion}
                    </div>
                )}
            </div>
        </div>
    );
};


// --- Componente de Visualização para Gráfico (GraphGen) ---
const GraphResultDisplay = ({ visualData }) => {
    if (!visualData?.image) return null;
    const imageSrc = `data:image/png;base64,${visualData.image}`;
    return (
        <div className="mt-4">
            <h4 className="text-md font-semibold text-white mb-2">Visualização do Gráfico:</h4>
            <div className="bg-gray-900 p-2 rounded-md">
                <img src={imageSrc} alt="Gráfico gerado" className="w-full h-auto rounded" />
            </div>
        </div>
    );
};

// --- Componente de Visualização para Predição (I4U Predict) ---
const PredictResultDisplay = ({ visualData }) => {
    if (!visualData?.predicoes || !Array.isArray(visualData.predicoes)) return null;
    const { acuracia, predicoes } = visualData;
    const headers = predicoes.length > 0 ? Object.keys(predicoes[0]) : [];

    return (
        <div className="mt-4">
            <h4 className="text-md font-semibold text-white mb-2">Resultados da Predição:</h4>
            <div className="bg-gray-900 p-4 rounded-md">
                {acuracia && (
                    <div className="mb-4">
                        <span className="font-semibold text-lg">Acurácia do Modelo:</span>
                        <span className="ml-2 text-lg font-bold text-green-400">{acuracia}</span>
                    </div>
                )}
                <div className="overflow-x-auto">
                    <table className="w-full text-left text-sm">
                        <thead className="bg-gray-700">
                            <tr>
                                {headers.map(header => (
                                    <th key={header} className="p-3 capitalize">{header.replace('_', ' ')}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {predicoes.map((row, index) => (
                                <tr key={index} className="border-b border-gray-800">
                                    {headers.map(header => (
                                        <td key={`${index}-${header}`} className={`p-3 ${header === 'previsao' ? 'font-bold text-orange-400' : ''}`}>
                                            {row[header]}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

// --- Componente de Visualização para Texto (Agentes Específicos) ---
const TextResultDisplay = ({ agentName, visualData }) => {
    if (!visualData) return null;
    let title = "Resultado em Texto:";
    let content = null;

    switch (agentName) {
        case "I4U Doc Analytics":
            if (visualData.analise && typeof visualData.analise === 'string') content = visualData.analise;
            else if (visualData.insights && Array.isArray(visualData.insights)) content = visualData.insights.join('\n');
            break;
        case "I4U Resume":
            if (visualData.analise) content = visualData.analise;
            break;
        case "I4U Feel":
            if (visualData.sentimento) content = `Sentimento: ${visualData.sentimento}`;
            break;
        case "I4U Summary":
             if (visualData.resumo) content = visualData.resumo;
            break;
        case "I4U QueryGen":
            if (visualData.consulta_sql) content = visualData.consulta_sql.replace(/```sql\n|```/g, '').trim();
            break;
        case "I4U Face Detect":
            if (visualData.resultado !== undefined) content = `Resultado: ${visualData.resultado === 1 ? "Sim, correspondem." : "Não correspondem."}`;
            break;
        default: return null;
    }

    if (!content) return null;

    return (
        <div className="mt-4">
            <h4 className="text-md font-semibold text-white mb-2">{title}</h4>
            <div className="bg-gray-900 p-4 rounded-md">
                <pre className="text-sm text-gray-300 whitespace-pre-wrap break-all">{content}</pre>
            </div>
        </div>
    );
};


// --- Componente de Visualização para Áudio (Podcast) ---
const AudioResultDisplay = ({ visualData }) => {
    if (!visualData?.audio_base64 || !visualData?.content_type) return null;
    const audioSrc = `data:${visualData.content_type};base64,${visualData.audio_base64}`;

    return (
        <div className="mt-4">
            <h4 className="text-md font-semibold text-white mb-2">Podcast Gerado:</h4>
            <div className="bg-gray-900 p-2 rounded-md">
                <audio controls src={audioSrc} className="w-full">
                    Seu navegador não suporta o elemento de áudio.
                </audio>
            </div>
        </div>
    );
};


// --- Componente da Página de Teste dos Agentes ---
const AgentsPage = ({ initialApiKey, onShowDashboard, onShowPlans }) => {
    const [apiKey, setApiKey] = useState(initialApiKey || '');
    const [loading, setLoading] = useState({});
    const [responses, setResponses] = useState({});
    const [visualData, setVisualData] = useState({});
    const [fileURLs, setFileURLs] = useState({});

    const executeApi = async (agent) => {
        if (!apiKey) {
            alert('Por favor, insira a sua chave de API para executar o agente.');
            return;
        }

        setLoading(prev => ({ ...prev, [agent.name]: true }));
        setResponses(prev => ({ ...prev, [agent.name]: null }));
        setVisualData(prev => ({ ...prev, [agent.name]: null }));
        setFileURLs(prev => ({ ...prev, [agent.name]: null }));

        const formData = new FormData();
        formData.append('agentName', agent.name);
        formData.append('apiKey', apiKey);

        let hasAllInputs = true;
        agent.inputs.forEach(input => {
            const el = document.getElementById(input.id);
            if (input.type === 'file') {
                if (el.files.length > 0) {
                    const file = el.files[0];
                    formData.append(input.id, file);
                    const fileURL = URL.createObjectURL(file);
                    setFileURLs(prev => ({...prev, [agent.name]: fileURL }));
                } else {
                    hasAllInputs = false;
                }
            } else {
                formData.append(input.id, el.value);
            }
        });

        if (!hasAllInputs) {
            alert('Por favor, preencha todos os campos necessários.');
            setLoading(prev => ({ ...prev, [agent.name]: false }));
            return;
        }

        try {
            const response = await fetch(`${API_BASE}/proxy-agent`, {
                method: 'POST',
                body: formData,
            });
            
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Ocorreu um erro na API.');
            }
            setResponses(prev => ({ ...prev, [agent.name]: JSON.stringify(data, null, 2) }));
            setVisualData(prev => ({ ...prev, [agent.name]: data }));

        } catch (error) {
            setResponses(prev => ({ ...prev, [agent.name]: `Erro: ${error.message}` }));
        } finally {
            setLoading(prev => ({ ...prev, [agent.name]: false }));
        }
    };

    const agentGroups = {
        "Agentes de Visão Computacional": [
            { name: "I4U Data Vision", id: "dataVision", inputs: [{ type: 'file', id: 'imgVision' }], description: "Classifique imagens com base em modelos de visão computacional.", visual: "image" },
            { name: "I4U Face Detect", id: "faceDetect", inputs: [{ type: 'file', id: 'imgRef', label: 'Imagem de Referência' }, { type: 'file', id: 'imgInput', label: 'Imagem de Comparação' }], description: "Compare duas imagens para verificar se a mesma pessoa aparece em ambas.", visual: "text" },
            { name: "I4U Mood Sense", id: "moodSense", inputs: [{ type: 'file', id: 'videoFile', accept: 'video/mp4' }], description: "Envie um vídeo com rosto humano para detectar emoções predominantes.", visual: "video" },
            { name: "I4U Car Crash", id: "carCrash", inputs: [{ type: 'file', id: 'carImg' }], description: "Envie uma imagem de carro para identificar e classificar os danos.", visual: "image" },
        ],
        "Agentes de Análise de Texto": [
            { name: "I4U Doc Analytics", id: "docAnalytics", inputs: [{ type: 'file', id: 'pdfDoc', accept: 'application/pdf' }], description: "Obtenha insights automáticos a partir de documentos enviados.", visual: "text" },
            { name: "I4U Resume", id: "resume", inputs: [{ type: 'file', id: 'resumePDF', accept: 'application/pdf' }, { type: 'textarea', id: 'promptResume', placeholder: "Descreva a vaga aqui...", defaultValue: "Analise para vaga de cientista de dados" }], description: "Envie um currículo e descreva a vaga desejada para análise de compatibilidade.", visual: "text" },
            { name: "I4U Feel", id: "feel", inputs: [{ type: 'textarea', id: 'textoSentimento', defaultValue: "Hoje estou muito feliz!" }], description: "Analise o sentimento predominante de um texto livre.", visual: "text" },
            { name: "I4U Summary", id: "summary", inputs: [{ type: 'file', id: 'pdfResumo', accept: 'application/pdf' }], description: "Resuma automaticamente o conteúdo de um documento PDF.", visual: "text" },
        ],
        "Agentes Assistentes": [
            { name: "I4U QueryGen", id: "queryGen", inputs: [{ type: 'file', id: 'ddlSQL' }, { type: 'text', id: 'promptQuery', defaultValue: "Liste todos os clientes cadastrados no último mês" }], description: "Gere automaticamente consultas SQL a partir de um DDL e uma instrução textual.", visual: "text" },
            { name: "I4U GraphGen", id: "graphGen", inputs: [{ type: 'file', id: 'csvGraph' }, { type: 'textarea', id: 'promptGraph', defaultValue: "Quero ver um gráfico de barras que compare o Estado e o PIB_PerCapita_2019" }], description: "Gere gráficos a partir de dados CSV e instruções em texto.", visual: "graph" },
            { 
                name: "I4U Podcast", 
                id: "podcast", 
                inputs: [
                    { type: 'file', id: 'podcastFile', accept: '.pdf,.docx,.txt', label: 'Arquivo (PDF, DOCX, TXT)' },
                    { type: 'select', id: 'language', label: 'Idioma', options: [{value: 'pt-BR', text: 'Português (Brasil)'}, {value: 'en-US', text: 'Inglês (EUA)'}] },
                    { type: 'select', id: 'voiceGender', label: 'Gênero da Voz', options: [{value: 'female', text: 'Feminino'}, {value: 'male', text: 'Masculino'}] },
                    { type: 'select', id: 'style', label: 'Estilo', options: [{value: 'comunicacao_interna', text: 'Comunicação Interna'}, {value: 'marketing', text: 'Marketing'}, {value: 'ead', text: 'EAD'}, {value: 'microlearning', text: 'Microlearning'}] },
                    { type: 'number', id: 'timeLimit', label: 'Tempo Limite (minutos)', defaultValue: 3 }
                ], 
                description: "Crie um podcast de áudio a partir de um documento de texto.", 
                visual: "audio" 
            },
        ],
        "Agentes de Predição": [
            { name: "I4U Predict", id: "predict", inputs: [{ type: 'file', id: 'trainCSV', label: "Arquivo de Treino (CSV)" }, { type: 'file', id: 'predictCSV', label: "Arquivo de Predição (CSV)" }, { type: 'text', id: 'target', defaultValue: "Classe", label: "Coluna Alvo" }], description: "Treine e aplique um modelo preditivo baseado nos dados enviados.", visual: "predict" },
        ]
    };

    return (
        <div className="bg-gray-900 min-h-screen text-white p-8">
            <div className="container mx-auto">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-4xl font-extrabold text-orange-400">Playground dos Agentes</h1>
                    <div className="flex gap-4">
                         <button onClick={onShowPlans} className="bg-orange-500 text-white font-semibold py-2 px-4 rounded-lg hover:bg-orange-600 transition-colors flex items-center gap-2">
                           <Sparkles className="h-5 w-5" />
                           <span>Ver Planos</span>
                        </button>
                        <button onClick={onShowDashboard} className="bg-gray-700 text-white font-semibold py-2 px-4 rounded-lg hover:bg-gray-600 transition-colors flex items-center gap-2">
                            <LayoutDashboard className="h-5 w-5" />
                            <span>Minha Conta</span>
                        </button>
                    </div>
                </div>

                <div className="mb-8 bg-gray-800 p-6 rounded-2xl border border-gray-700 shadow-lg">
                    <label htmlFor="apiKeyInput" className="flex items-center gap-2 text-lg font-semibold text-white mb-2">
                        <KeyRound className="h-6 w-6 text-orange-400" />
                        Sua Chave de API
                    </label>
                    <p className="text-sm text-gray-400 mb-4">Cole a sua chave de API abaixo para autenticar as suas requisições. Pode encontrar a sua chave na página "Minha Conta".</p>
                    <input
                        type="text"
                        id="apiKeyInput"
                        value={apiKey}
                        onChange={(e) => setApiKey(e.target.value)}
                        placeholder="Cole a sua chave de API aqui"
                        className="w-full bg-gray-900 border border-gray-600 rounded-md p-3 text-sm text-white focus:ring-2 focus:ring-orange-500 focus:border-orange-500 font-mono"
                    />
                </div>

                {Object.entries(agentGroups).map(([groupName, agents]) => (
                    <div key={groupName} className="mb-12">
                        <h2 className="text-3xl font-bold text-white mb-6 border-b-2 border-orange-500 pb-2">{groupName}</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-8">
                            {agents.map(agent => (
                                <div key={agent.id} className="bg-gray-800 rounded-2xl p-6 border border-gray-700 flex flex-col gap-4">
                                    <h3 className="text-xl font-bold text-orange-400">{agent.name}</h3>
                                    <p className="text-sm text-gray-400 flex-grow">{agent.description}</p>
                                    <div className="space-y-4">
                                        {agent.inputs.map(input => (
                                            <div key={input.id}>
                                                {input.label && <label className="text-xs text-gray-300 mb-1 block">{input.label}</label>}
                                                {input.type === 'textarea' ? (
                                                    <textarea id={input.id} defaultValue={input.defaultValue} placeholder={input.placeholder} className="w-full bg-gray-900 border border-gray-600 rounded-md p-2 text-sm h-24 resize-none"></textarea>
                                                ) : input.type === 'select' ? (
                                                    <select id={input.id} className="w-full bg-gray-900 border border-gray-600 rounded-md p-2 text-sm">
                                                        {input.options.map(option => (
                                                            <option key={option.value} value={option.value}>{option.text}</option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    <input type={input.type} id={input.id} defaultValue={input.defaultValue} accept={input.accept} className="w-full bg-gray-900 border border-gray-600 rounded-md p-2 text-sm" />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                    <button onClick={() => executeApi(agent)} disabled={loading[agent.name]} className="w-full mt-2 bg-orange-500 text-white font-semibold py-2 rounded-lg hover:bg-orange-600 transition-colors disabled:bg-gray-500">
                                        {loading[agent.name] ? 'Executando...' : 'Executar'}
                                    </button>
                                    
                                    <div className="mt-4 space-y-4">
                                        {agent.visual === 'image' && visualData[agent.name] && fileURLs[agent.name] && (
                                            <ImageResultDisplay 
                                                agentId={agent.id}
                                                fileURL={fileURLs[agent.name]}
                                                visualData={visualData[agent.name]}
                                            />
                                        )}

                                        {agent.visual === 'video' && visualData[agent.name] && fileURLs[agent.name] && (
                                            <VideoResultDisplay
                                                agentId={agent.id}
                                                fileURL={fileURLs[agent.name]}
                                                visualData={visualData[agent.name]}
                                            />
                                        )}
                                        
                                        {agent.visual === 'graph' && visualData[agent.name] && (
                                            <GraphResultDisplay
                                                visualData={visualData[agent.name]}
                                            />
                                        )}

                                        {agent.visual === 'predict' && visualData[agent.name] && (
                                            <PredictResultDisplay
                                                visualData={visualData[agent.name]}
                                            />
                                        )}
                                        
                                        {agent.visual === 'text' && visualData[agent.name] && (
                                            <TextResultDisplay
                                                agentName={agent.name}
                                                visualData={visualData[agent.name]}
                                            />
                                        )}

                                        {agent.visual === 'audio' && visualData[agent.name] && (
                                             <AudioResultDisplay
                                                visualData={visualData[agent.name]}
                                            />
                                        )}

                                        {responses[agent.name] && (
                                            <div className="bg-gray-900 p-4 rounded-md">
                                                <h4 className="text-md font-semibold text-white mb-2">Resposta JSON:</h4>
                                                <pre className="text-xs text-green-400 whitespace-pre-wrap break-all overflow-x-auto max-h-60"><code>{responses[agent.name]}</code></pre>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};


// --- Componente Principal (Roteador) ---
export default function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [view, setView] = useState('pricing');
    const [currentApiKey, setCurrentApiKey] = useState(null);
	const [dashboardKey, setDashboardKey] = useState(0);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            if (currentUser) {
                // Se o utilizador estiver logado, vai para o dashboard por defeito
                setView('dashboard');
            } else {
                // Se não, vai para os preços
                setView('pricing');
            }
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);
    
    // Função para navegar para o playground, opcionalmente com uma chave
    const handleShowAgents = (apiKey) => {
        setCurrentApiKey(apiKey); // Guarda a chave para passar como prop
        setView('agents');
    };

    const handleActivationSuccess = () => {
        setDashboardKey(prevKey => prevKey + 1);
        setView('dashboard');
    };

    const query = new URLSearchParams(window.location.search);
    const sessionId = query.get('session_id');

    if (loading) {
        return <div className="bg-gray-900 h-screen flex items-center justify-center text-white">A carregar...</div>;
    }

    if (sessionId) {
        return <SuccessDisplay sessionId={sessionId} user={user} />;
    }

    // Lógica de Roteamento
    switch (view) {
        case 'agents':
            return <AgentsPage 
                        initialApiKey={currentApiKey} 
                        onShowDashboard={() => setView('dashboard')} 
                        onShowPlans={() => setView('pricing')} 
                    />;
        case 'dashboard':
            if (user) {
                return <DashboardPage 
                            key={dashboardKey}
                            user={user} 
                            onShowPlans={() => setView('pricing')} 
                            onShowAgents={handleShowAgents} 
                        />;
            }
            // Se tentar aceder ao dashboard sem estar logado, redireciona para os preços.
            return <PricingPage 
                        user={null} 
                        onShowDashboard={() => setView('dashboard')} 
                        onShowAgents={handleShowAgents}
                        onActivationSuccess={handleActivationSuccess}
                    />;
        case 'pricing':
        default:
            return <PricingPage 
                        user={user} 
                        onShowDashboard={() => setView('dashboard')} 
                        onShowAgents={handleShowAgents}
                        onActivationSuccess={handleActivationSuccess}
                    />;
    }
}